import React from 'react'

import { useTranslation } from 'react-i18next'

import {
  ASYNC_SEARCH_LIMIT,
  TEXTFIELD_ALLOW,
  TEXTFIELD_REQUIRED_LENGTH,
} from '~/common/constants'
import { Field } from '~/components/Formik'
import { VIETNAM_PROVINCES } from '~/modules/public/features/contact/dummy-data'

const FilterForm = () => {
  const { t } = useTranslation('mkt')

  return (
    <>
      <Field.TextField
        name="email"
        // label={t('defineCustomer.code')}
        placeholder={t('guest.workEmail')}
        inputProps={{
          maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }}
        allow={TEXTFIELD_ALLOW.REGEX_CODE_VIETNAMESE_JAPANESE}
      />
      <Field.TextField
        name="name"
        // label={t('defineCustomer.name')}
        placeholder={t('guest.fullName')}
        inputProps={{
          maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }}
        allow={TEXTFIELD_ALLOW.REGEX_CODE_VIETNAMESE_JAPANESE}
      />{' '}
      <Field.TextField
        name="phone"
        // label={t('defineCustomer.name')}
        placeholder={t('guest.phoneNumber')}
        inputProps={{
          maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }}
        allow={TEXTFIELD_ALLOW.REGEX_CODE_VIETNAMESE_JAPANESE}
      />{' '}
      <Field.TextField
        name="area"
        // label={t('defineCustomer.name')}
        placeholder={t('guest.area')}
        inputProps={{
          maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }}
        allow={TEXTFIELD_ALLOW.REGEX_CODE_VIETNAMESE_JAPANESE}
      />
      {/* <Field.Autocomplete
        name="countryId"
        // label={t('defineCustomer.address')}
        placeholder={t('guest.area')}
        options={VIETNAM_PROVINCES}
        getOptionLabel={(opt) => (opt ? opt : '')}
        getOptionValue={(opt) => opt}
      /> */}
    </>
  )
}

export default FilterForm
